import { useStyletron } from "baseui";
import { StyledSvg } from "baseui/icon";
import React from "react";

export const DocsInfoIcon = (props: React.ComponentProps<typeof StyledSvg> & { color: string }) => {
  const [_css, $theme] = useStyletron();
  return (
    <StyledSvg {...props} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99976 2C5.58176 2 1.99976 5.582 1.99976 10C1.99976 14.418 5.58176 18 9.99976 18C14.4178 18 17.9998 14.418 17.9998 10C17.9998 5.582 14.4178 2 9.99976 2ZM10.6664 14H9.33309V9.33333H10.6664V14ZM9.99976 7.66667C9.44776 7.66667 8.99976 7.21867 8.99976 6.66667C8.99976 6.11467 9.44776 5.66667 9.99976 5.66667C10.5518 5.66667 10.9998 6.11467 10.9998 6.66667C10.9998 7.21867 10.5518 7.66667 9.99976 7.66667Z"
        fill={props.color ?? $theme.colors.primary500}
      />
    </StyledSvg>
  );
};
